import { useState, useEffect, useContext } from 'react'
import { dispatch, useSelect } from '@wordpress/data'

import ContextChoose from './ContextChoose'
import { DataGridChoose } from "./DataGridChoose"
import { useAddUserOpti } from '../../api/controllers/empresas'
import { store } from '../../redux/store'
import ModalWelcome from './ModalWelcome'
import CircularProgress from '../../componentsNew/CircularProgress'
import Typography from '../../componentsNew/Typography'
import { CarregandoDadosSistema } from '../../componentsNew/CarregandoDadosSistema'
import { useAction } from '../../api/actions/action'

export function ChooseArticles() {
    const { rows } = useContext(ContextChoose)
    //const blogData = useSelect(select => select('core/editor').getSite())
    //const { title: blogName, url: blogURL } = blogData || {}
    const articleCount = rows ? rows.length : 0
    const { mutate: mutateAction, data: blogData } = useAction();

    const userInfo = useSelect((select) => select(store).getUserLoggedIn());

    useEffect(() => {
        mutateAction('get_blog_info')
        if (userInfo === null && userInfo === undefined) {
            resolveSelect(store).getUserLoggedIn()
        }
    }, [userInfo]);

    const { mutateAsync: addUsuario, data: usuario } = useAddUserOpti()

    useEffect(() => {
        if (userInfo?.display_name && blogData?.data) {
            addUsuario({
                email: userInfo.user_email,
                nomeUsuario: userInfo.display_name,
                nomeBlog: blogData?.data?.name,
                urlBlog: blogData?.data?.url,
                totalArtigos: articleCount,
                senha: ""
            })
        }
    }, [userInfo, blogData])

    useEffect(() => {
        if (usuario?.data && usuario?.data?.usuarioWordpress) {
            dispatch(store).setBlogIdOpti(usuario?.data?.usuarioWordpress.id)
        }
    }, [usuario])

    return (
        <>
            <div className="flex flex-col items-center justify-center h-[90vh] left-40 top-4">

                {usuario?.data && localStorage.getItem("popup-opti") !== "true" &&
                    <DataGridChoose
                        dataUserOpti={usuario}
                        //contaEscolhida={contaEscolhida}
                        //propriedadeEscolhida={propriedadeEscolhida}
                        //googleApi={googleApi}
                    />
                }

                {!usuario?.data &&
                    <div className="flex flex-col gap-4 items-center justify-center">
                        <CarregandoDadosSistema/>
                    </div>
                }
            </div>

            <ModalWelcome />
        </>
    )
}
